import Api from './api'

export const tourLogin = (payload) =>
{

    let {name, password} = payload;
    
    var data = { 
        username: name,
        password: password
    }
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`https://app-maquetas.herokuapp.com/api/authenticate`, requestOptions);
    /*return Api().post('/api/authenticate', JSON.stringify(data), {
        headers: {
            "Content-Type": 'application/json',
            "x-api-key": "1Nt3r4ct1v3",
        }
    })*/
}

export async function getProyecto(){
    var idProyecto = '623a02cc8114470018128153';

    return Api().get('/api/proyectos/get/'+idProyecto, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}

export async function  getProyectos(){
    return Api().get('/api/proyectos/get/', {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}

export async function  getDropboxFiles(){
    var data = { path: "/Constructoras/MAS Developers/Casa Ambar/" }

    return Api().post('/api/dropbox/file-list', data, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}